import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import GetTheComapnyBoywithpinacular from "../../assets/images/boywithpinacular.png";
import { ReactComponent as Image } from "../../assets/images/getthecompany.svg";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo, clearUserInfo, hideModal } from "../../../src/store/auth/authSlice";
import { ReactComponent as Warning } from '../../assets/icons/Warning.svg'

export const SessionExpired = ({ message = "Session Expired", subMessage = "Try login again to access the site" }) => {
  const location = useLocation();
  const isPrompt = location.pathname.includes("prompt")
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigate = () => {
    dispatch(clearUserInfo());
    dispatch(hideModal());
    navigate(isPrompt ? "/login/prompt":"/login");
  };
  return (
    <div className="text-center flex flex-col items-center">
      <div className="sessionexpired">
        <Warning />
      </div>
      <h3 className="text-secondarytwo text-f20 font-semibold">
        {message}
      </h3>
      <p className="text-secondary pt-2 pb-4 w-80 text-f14">{subMessage}</p>
      <hr />
      <button
        onClick={handleNavigate}
        className="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
      >
        OK
      </button>
      <div className="flex justify-between text-secondary pt-4 items-center"></div>
    </div>
  );
};
